import { Button } from '@/components/ui/button';
import { Check } from 'lucide-react';

export const PricingCard = ({ 
  title, 
  price, 
  features, 
  recommended = false, 
  onCTAClick,
  variant = 'outline' 
}) => {
  return (
    <div 
      className={`${
        recommended 
          ? 'bg-accent/10 border-2 border-accent' 
          : 'bg-white border border-border'
      } p-6 relative flex flex-col h-[500px]`}
      data-testid={`pricing-${title.toLowerCase()}`}
    >
      {recommended && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-accent text-white px-4 py-1 text-xs uppercase tracking-widest font-bold">
          Recommended
        </div>
      )}
      
      <h3 className="text-2xl font-bold text-primary mb-2">{title}</h3>
      <div className="mb-4">
        <span className="text-4xl font-bold text-primary">${price}</span>
        <span className="text-muted-foreground text-sm"> + Federal Filing Fee</span>
      </div>
      
      <div className="flex-1 overflow-y-auto mb-4 pr-2">
        <ul className="space-y-2">
          {features.map((feature, index) => (
            <li key={index} className="flex items-start gap-2">
              <Check className="h-4 w-4 text-accent mt-0.5 flex-shrink-0" />
              <span className="text-sm text-muted-foreground">{feature}</span>
            </li>
          ))}
        </ul>
      </div>
      
      <p className="text-xs text-muted-foreground mb-4">(Govt. filing fee not included)</p>
      
      <Button 
        onClick={onCTAClick} 
        variant={recommended ? 'default' : variant}
        className={`w-full mt-auto ${recommended ? 'bg-primary hover:bg-primary/90 text-white' : ''}`}
      >
        Get Started
      </Button>
    </div>
  );
};
